<template>
	<div
		@click="$emit('click')"
		class="xs-12 r2 pt3 pb3 cu2 case-management-value"
	>
		<slot></slot>

		<!-- Remove button displayed on hover and only if hasRemove === true -->
		<div
			v-if="hasRemove"
			class="flex fs3 p2 fw7 c6 xs-center xs-middle case-management-close"
			@click.stop="$emit('remove:clicked')"
		>
			✕
		</div>
	</div>
</template>

<script>
export default {
	props: {
		hasRemove: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped>
.case-management-value {
	position: relative;
	background-color: rgba(0, 0, 0, 0);
}

.case-management-value:hover {
	background-color: rgba(0, 0, 0, 0.06);
}

.case-management-close {
	display: none;
	width: 20px;
	height: 20px;
	border-radius: 100%;
	position: absolute;
	right: 8px;
	top: 50%;
	transform: translateY(-50%);
	background-color: rgba(0, 0, 0, 0.09);
	z-index: 10;
}

.case-management-value:hover .case-management-close {
	display: flex;
}
</style>
